import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import isEmpty from "lodash/isEmpty";

import { useRetailerNodes } from "../retailer/useRetailerNodes";

import { useSelfServeContextStore } from "./SelfServeContext";
import { useBrandNodes } from "./useBrandNodes";

export const useTree = () => {
  const [{ tree }, setSelfServeContextStore] = useSelfServeContextStore([
    "tree",
  ]);
  const RETAILER_NODES = useRetailerNodes();
  const BRAND_NODES = useBrandNodes();
  if (!isEmpty(tree)) {
    return { tree };
  }
  const lazilyConstructedNodes = isRetailer() ? RETAILER_NODES : BRAND_NODES;
  setSelfServeContextStore({ tree: lazilyConstructedNodes });
  return { tree: lazilyConstructedNodes };
};
